import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReelShowcase from "../components/mh/ReelShowcase";
import Statement from "../components/mh/Statement";
import Marquee from "../components/mh/Marquee";
import WorkSection from "../components/mh/WorkSection";
import BrandsMarquee from "../components/mh/BrandsMarquee";

// Home — composes the landing experience.
// Hash deep-links (e.g. `/#work`) are scroll-restored once the route mounts.
export const Home = ({ loaded }) => {
    const { hash } = useLocation();

    useEffect(() => {
        if (!hash) return;
        const id = setTimeout(() => {
            const el = document.querySelector(hash);
            if (!el) return;
            if (window.__lenis) {
                window.__lenis.scrollTo(el, { offset: -20, duration: 1.4 });
            } else {
                el.scrollIntoView({ behavior: "smooth" });
            }
        }, 250);
        return () => clearTimeout(id);
    }, [hash]);

    return (
        <main>
            <ReelShowcase active={loaded} />
            <Statement />
            <Marquee
                items={[
                    "VFX",
                    "Color",
                    "CGI",
                    "Motion",
                    "AI",
                    "Commercials",
                    "Music Videos",
                    "Brand Films"
                ]}
            />
            <WorkSection />
            <BrandsMarquee />
        </main>
    );
};

export default Home;
